/**
 * EDS primary text button — same visual as updated `Button`.
 * Prefer this name in new EDS call sites; `Button` remains the shared export.
 */
export { Button as ButtonEds } from './Button';
